import { createTheme, ITheme } from '@fluentui/react';

/**
 * Boroondara light theme (Fluent UI v8).
 * Aligned with official City of Boroondara brand: green accents, Roboto font.
 */
export const boroondaraPalette = {
  bg: '#FFFFFF',
  bg2: '#f8f9fa',
  panel: '#FFFFFF',
  panel2: '#f8f7f7',
  border: '#D1D5DB',
  borderSoft: '#E5E7EB',
  text: '#232323',
  text2: '#484848',
  text3: '#747474',
  primary: '#2e873d',
  accent: '#55a655',
  primaryHover: '#237131',
  primaryActive: '#0d3a1c',
  selectedBg: '#d9f4d7',
  lightTint: '#f3fcf3',
};

export const boroondaraTheme: ITheme = createTheme({
  palette: {
    themePrimary: '#2e873d',
    themeLighterAlt: '#f3fcf3',
    themeLighter: '#a4d99b',
    themeLight: '#7bc87a',
    themeTertiary: '#55a655',
    themeSecondary: '#3d9a48',
    themeDarkAlt: '#237131',
    themeDark: '#237131',
    themeDarker: '#0d3a1c',

    neutralLighterAlt: '#FAFAFA',
    neutralLighter: '#f8f9fa',
    neutralLight: '#E5E7EB',
    neutralQuaternaryAlt: '#D1D5DB',
    neutralQuaternary: '#C4C9D0',
    neutralTertiaryAlt: '#B0B7BF',
    neutralTertiary: '#9CA3AF',
    neutralSecondary: '#747474',
    neutralPrimaryAlt: '#484848',
    neutralPrimary: '#232323',
    neutralDark: '#232323',

    black: '#000000',
    white: '#FFFFFF',
  },
  semanticColors: {
    bodyBackground: '#FFFFFF',
    bodyBackgroundChecked: '#f8f9fa',
    bodyStandoutBackground: '#f8f9fa',

    bodyText: '#232323',
    bodyTextChecked: '#232323',
    disabledBodyText: '#9CA3AF',
    bodySubtext: '#484848',

    link: '#2e873d',
    linkHovered: '#237131',

    listBackground: '#FFFFFF',
    listText: '#232323',
    listItemBackgroundHovered: '#f8f9fa',

    inputBackground: '#FFFFFF',
    inputBorder: '#D1D5DB',
    inputBorderHovered: '#9CA3AF',
    inputText: '#232323',
    inputPlaceholderText: '#747474',

    menuBackground: '#FFFFFF',
    menuDivider: '#E5E7EB',
    menuItemBackgroundHovered: '#f8f9fa',
    menuItemBackgroundPressed: '#E5E7EB',
    menuItemText: '#232323',
    menuItemTextHovered: '#232323',

    variantBorder: '#E5E7EB',
    variantBorderHovered: '#9CA3AF',
  },
  defaultFontStyle: {
    fontFamily:
      "'Roboto','Segoe UI',system-ui,-apple-system,BlinkMacSystemFont,Oxygen,Ubuntu,Cantarell,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif",
  },
});
